import {Injectable} from '@angular/core';
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import {ServiceProviderHub} from '@generated-backend-types';
import Occurrence = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Occurrence.Occurrence;

@Injectable({providedIn: 'root'})
export class OccurrenceService extends BaseApiEndpointService<Occurrence> {
  protected override endpoint = '/occurrences';
  public override readonly multiSelectSortBy: keyof Occurrence = 'internal_title';

  modelToMultiSelectItem(m: Occurrence): ListItem & {
    model: Occurrence
  } {
    return {
      id: m.id,
      text: m.internal_title,
      isDisabled: false,
      model: m,
    };
  }
}
